<template>
  <div class="min-h-screen">
    <div class="pagination-bg pagination-bg-sm pagination-bg-lg pagination-bg-2xl bg-center">
      <div class="max-w-7xl mx-auto pt-16 sm:pt-20">
        <div class="flex justify-center">
          <img
            src="@/assets/news.svg"
            alt="最新消息"
            class="sm:w-16 sm:h-16"
          />
        </div>
        <h1 class="text-3xl sm:text-4xl font-black mt-5">最新消息</h1>
      </div>
    </div>
    <div class="max-w-7xl mx-auto mt-10 pb-20 px-10">
      <div class="flex space-x-5 justify-start mb-10">
        <div class="font-bold text-lg text-left flex-none">
          <router-link to="/">首頁</router-link>
        </div>
        <p class="text-lg">></p>
        <div class="text-lg font-bold text-left flex-none">
          <router-link to="/news">最新消息</router-link>
        </div>
        <p class="text-lg">></p>
        <!-- 麵包屑 -->
        <p class="text-lg text-color-blue font-bold text-left truncate w-80">{{ newsData.title }}</p>
      </div>
      <!-- 標題 -->
      <div class="flex justify-center text-2xl font-bold">{{ newsData.title }}</div>
      <div class="sm:flex sm:space-x-5 space-y-5 sm:space-y-0 text-lg my-10">
        <div class="flex items-start space-x-5">
          <div class="content-bg text-white rounded-full px-3 flex-none">作&emsp;者</div>
          <!-- 作者 -->
          <p class="text-left">{{ newsData.author }}</p>
        </div>
        <div class="flex items-start space-x-5">
          <div class="content-bg text-white rounded-full px-3 flex-none">日&emsp;期</div>
          <!-- 日期 -->
          <p class="text-left">{{ newsData.date }}</p>
        </div>
      </div>
      <!-- 內容 -->
      <div
        class="mt-20 text-lg"
        v-html="newsData.contents"
      >
      </div>

      <div
        v-if="newsData.attachments && newsData.attachments.length > 0"
        class="mt-10"
      >
        <h3 class="text-xl font-bold mb-5">附件下載</h3>
        <div class="space-y-3">
          <div
            v-for="attachment in newsData.attachments"
            :key="attachment.uid"
            class="flex items-center"
          >
            <img
              src="@/assets/download.svg"
              alt="下載"
              class="w-5 h-5 mr-3"
            >
            <a
              href="javascript:void(0)"
              @click="downloadFile(attachment.response.url, attachment.name)"
              class="text-color-blue hover:text-color-blue-dark hover:underline"
            >
              {{ attachment.name }}
            </a>
            <span class="ml-3 text-gray-500 text-sm">({{ formatFileSize(attachment.size) }})</span>
          </div>
        </div>
      </div>

      <div class="flex justify-center">
        <div
          class="cursor-pointer"
          @click="$router.back()"
        >
          <div class="pagination-btn text-white flex items-center justify-center mt-10">回上頁</div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bg"></div>
</template>

<script>
import * as newsApi from '@/api/news'

export default {
  title: '最新消息-TAIE',
  data () {
    return {
      newsId: this.$route.params.id,
      newsData: []
    }
  },
  methods: {
    formatFileSize (size) {
      if (size < 1024) return size + ' B'
      else if (size < 1048576) return (size / 1024).toFixed(1) + ' KB'
      else return (size / 1048576).toFixed(1) + ' MB'
    },
    async downloadFile (url, filename) {
      try {
        // 獲取檔案內容
        const response = await fetch(url)
        const blob = await response.blob()

        // 創建下載連結
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename

        // 觸發下載
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // 釋放URL對象
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.error('下載失敗:', error)
        alert('下載失敗，請稍後再試')
      }
    }
  },
  mounted () {
    newsApi.showNews(this.newsId).then(
      (response) => {
        this.newsData = response.data
      },
      (error) => {
        this.content =
          (error.response && error.response.data && error.response.data.message) ||
          error.message || error.toString()
      }
    )
  }
}
</script>

<style scoped>
@media (min-width: 1536px) {
  .pagination-bg-2xl {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .pagination-bg-lg {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .pagination-bg-sm {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over640.jpg");
  }
}

@media (max-width: 639.98px) {
  .pagination-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/pagination-bg-under640.jpg");
  }
}

a:hover {
  color: #64859D;
}

.text-color-blue {
  color: #64859D;
}

.text-color-blue-dark {
  color: #4A6477;
}

.content-bg {
  background-color: #64859D;
}

.pagination-btn {
  width: 100px;
  height: 40px;
  background-color: #C9A798;
  mask-image: url(../../assets/btn-bg.svg);
}

.pagination-btn:hover {
  background-color: #A8897C;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg.svg");
}
</style>
